import React from "react";
import {useLottie} from "lottie-react";

/**
 * Thin wrapper around lottie-react's named `useLottie` hook
 * (avoids the default-export interop issue). Size it via `className`.
 */
const LottieView = ({animationData, loop = false, className = ""}) => {
    const {View} = useLottie(
        {animationData, loop, autoplay: true},
        {width: "100%", height: "100%"}
    );

    return <div className={className}>{View}</div>;
};

export default LottieView;